import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box } from '@mui/material';
import { benefitsOptions, risksOptions, alternativesOptions } from '../constants/options';

const RisksBenefitsSection = ({ formData, setFormData, errors }) => {
  const handleAutocompleteChange = (name, newValue) => {
    setFormData(prev => ({ ...prev, [name]: newValue }));
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 4: Clinical Consideration
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={benefitsOptions}
            value={formData.benefits_of_surgery || ''}
            onInputChange={(_, newVal) => handleAutocompleteChange('benefits_of_surgery', newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Benefits of Surgery *"
                required
                fullWidth
                multiline
                rows={2}
                error={!!errors.benefits_of_surgery}
                helperText={errors.benefits_of_surgery}
              />
            )}
          />
        </Grid>
        
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={risksOptions}
            value={formData.risks_of_surgery || ''}
            onInputChange={(_, newVal) => handleAutocompleteChange('risks_of_surgery', newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Risks of Surgery *"
                required
                fullWidth
                multiline
                rows={2}
                error={!!errors.risks_of_surgery}
                helperText={errors.risks_of_surgery}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={alternativesOptions}
            value={formData.alternatives_to_surgery || ''}
            onInputChange={(_, newVal) => handleAutocompleteChange('alternatives_to_surgery', newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Alternatives to Surgery *"
                required
                fullWidth
                multiline
                rows={2}
                error={!!errors.alternatives_to_surgery}
                helperText={errors.alternatives_to_surgery}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RisksBenefitsSection;
